// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"ba61a418","859":"6a5ca9b7"}[chunkId] + ".chunk.js";
};